import { Component, OnInit, Input, Output, ViewEncapsulation, ViewChild, ElementRef } from '@angular/core';
import { Subject, timer } from 'rxjs';
import { debounce, distinctUntilChanged } from 'rxjs/operators';
@Component({
  selector: 'app-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.less']
})
export class TextInputComponent implements OnInit {
  @Input() property : string;
  @Input() model : any;
  @Input() type : string;
  @Input() label : string;
  @Input() icon : string;
  @Input() info : string;
  @Input() pretext : string;
  @Input() append : string;
  @Input() size : string;
  @Input() length : number;
  @Input() numbersOnly : string;
  @Input() required: string;
  @Input() placeholder : string;
  @Input() readonly : boolean;
  @Output() modelChanged = new Subject<any>();
  @Output() changeComplete = new Subject<any>();

  constructor() {
    this.modelChanged.pipe(debounce(()=> timer(3000)))
   }

  ngOnInit() {
  }

  changesComplete() {
    if(this.type == 'checkbox') {
      let el = <HTMLInputElement>document.getElementById(this.property);
      this.model = el.checked;
    }
    this.changeComplete.next({
      name: this.property,
      value: this.model
    })
  }

  changes(evt : any) {
    //some special handling for checkboxes here...
    if(this.type == 'checkbox') {
      let el = <HTMLInputElement>document.getElementById(this.property);
      this.model = el.checked;
    }
    this.modelChanged.next({
      name: this.property,
      value: this.model
    })
  }
}
